import React, { useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { LiliButton, LiliButtonType } from '@lili/lili-frontend-common';
import Heading from '../../generic-components/Heading';
import { LiliToolTip } from '../../generic-components/LiliToolTip';
import { PROFILE_STYLES } from '../../flows/profile/constants';
import { ISocialShareProps } from './types';
import { getShareableLinks } from './utils';
import { SocialShareItem } from './SocialShareItem';

export const SocialSharePopUp = ({ recipientName, invoiceNumber, paymentUrl }: ISocialShareProps) => {
  const [isCopyActive, setIsCopyActive] = useState<boolean>(false);
  const { t } = useTranslation();
  const shareableLinks = useMemo(getShareableLinks, []);

  useEffect(() => {
    if (isCopyActive) {
      window.navigator.clipboard.writeText(paymentUrl || '');
      setTimeout(() => {
        setIsCopyActive(false);
      }, 1500);
    }
  }, [isCopyActive]);

  return (
    <div className='absolute inset-0 bg-bw08Opacity backdrop-blur-sm flex items-center justify-center fadeIn'>
      <div className='bg-bw00 text-center flex flex-col items-center rounded-[8px] py-[30px] px-[30px] max-w-[500px]'>
        <Heading title={t('SHARE_INVOICE')} className='font-metricRMedium text-bw08 heading-[32px] text-[24px]' />
        <Heading
          title={t('SHARE_INVOICE_SUB_TITLE')}
          className='font-metricR text-bw07 heading-[24px] text-[16px] mb-[18px]'
        />
        <SocialShareItem
          recipientName={recipientName}
          invoiceNumber={invoiceNumber}
          paymentUrl={paymentUrl}
          shareItems={shareableLinks}
        />
        <div className='flex items-center justify-between w-full rounded-[8px] border border-bw03 px-[10px] py-[5px] mt-[24px]'>
          <LiliToolTip
            tooltipClassName='max-w-[70%] relative'
            toolTipChildren={
              <Heading
                title={paymentUrl || ''}
                className='font-metricR text-bw08 text-[14px] w-[420px] break-words leading-[20px]'
              />
            }
            conditionalAppearance
          >
            <Heading
              title={paymentUrl || ''}
              className='font-metricR text-bw08 text-[14px] w-full truncate leading-[20px]'
            />
          </LiliToolTip>

          <LiliToolTip
            childrenClassName={PROFILE_STYLES.COPY_TOOLTIP}
            tooltipClassName='w-fit relative'
            toolTipChildren={
              isCopyActive ? (
                ''
              ) : (
                <Heading title={t('ACCOUNT_DETAILS_COPY_SHORT')} className='text-bw00 font-metric text-[14px]' />
              )
            }
          >
            <LiliButton
              title={isCopyActive ? t('COPY_LINK_ACTIVE') : t('COPY_LINK')}
              type={LiliButtonType.BACK}
              id='elBtnCopyUrl'
              onClick={() => setIsCopyActive(true)}
            />
          </LiliToolTip>
        </div>
      </div>
    </div>
  );
};
